import { Derivative } from "./derivative";
import { STOCK_TYPE } from "@helpers/constants";

export class Stock extends Derivative {
	public getCurrencyType(): string {
		return STOCK_TYPE;
	}
}
